import { RenderMorphemViewer, DownloadSvg, DownloadPng } from './assets/js/app';
import { getPOSTag, getTagColor, getTagKorea } from './assets/js/tagStyle';

// if (window) {
//   window.RenderMorphemViewer = RenderMorphemViewer;
//   window.DownloadSvg = DownloadSvg;
//   window.DownloadPng = DownloadPng;
//   if (process.env.NODE_ENV !== "production") {
//     window.jsonData = require("./assets/data").newTags;
//   }
// }
export {
  RenderMorphemViewer,
  DownloadSvg,
  DownloadPng,
  getPOSTag,
  getTagColor,
  getTagKorea
};
